import { Box, Chip, TextField } from '@mui/material';
import { BaseTextFieldProps } from '@mui/material/TextField';
import { FC } from 'react';
import EllipsisText from './EllipsisText';
import { REMOVE_TAG_TEXT, chipWidth } from '@constants';
import styled from 'styled-components';
import cn from 'classnames';

export const ChipsContainer = styled(Box)`
  .red-chip {
    background-color: ${(props) => props.theme.palette.error.main};
    color: ${(props) => props.theme.palette.common.white};
  }
`;

interface TagsListSectionWithInputProps {
  tagList: string[];
  onDelete: (id: string) => void;
  inputRef?: BaseTextFieldProps['inputRef'];
  onKeyDown?: BaseTextFieldProps['onKeyDown'];
  helperText?: string;
  disabled?: BaseTextFieldProps['disabled'];
  error?: BaseTextFieldProps['error'];
  placeholder?: BaseTextFieldProps['placeholder'];
  label?: BaseTextFieldProps['label'];
  type?: BaseTextFieldProps['type'];
}

export const TagsListSectionWithInput: FC<TagsListSectionWithInputProps> = ({
  tagList,
  onDelete,
  inputRef,
  onKeyDown,
  helperText,
  placeholder,
  disabled,
  label,
  type = 'text',
  error,
}) => {
  return (
    <>
      <TextField
        type={type}
        placeholder={placeholder}
        inputRef={inputRef}
        onKeyDown={onKeyDown}
        helperText={helperText}
        disabled={disabled}
        error={error}
        label={label}
      />
      <ChipsContainer sx={{ display: 'flex', gap: 4, flexWrap: 'wrap', my: 3 }}>
        {tagList.map((tag) => (
          <EllipsisText key={tag} text={tag} width={chipWidth}>
            <Chip
              color="primary"
              className={cn({ 'red-chip': tag === REMOVE_TAG_TEXT })}
              label={tag}
              onDelete={() => onDelete(tag)}
              style={{ maxWidth: `calc(${chipWidth} - 10%)` }}
            />
          </EllipsisText>
        ))}
      </ChipsContainer>
    </>
  );
};
